export const amountFields = [
  'penaltyAmount',
  'taxAmt',
  'totalAmount',
  'totalFees',
];

export const TRIAL_BUILD_NOTE = 'Trial: Summary, Collection Summary and TIF Breakdown print manual records as entered. Build Records adds collected taxes to this trial.';

// A trial Build also pulls collected taxes into the trial unless "Manual records only" is ticked,
// so ask first when manual trial rows already exist.
export const shouldConfirmTrialBuild = ({ manualOnly, isTrialSelected, hasManualRows }) => (
  !manualOnly && Boolean(isTrialSelected) && Boolean(hasManualRows)
);

// The record sent to the upsert mutation. fromDate/toDate/businessDate must already be
// YYYY-MM-DD or null: the backend GraphQLDate type rejects MM-DD-YYYY and '' with an HTTP 500,
// for Normal and Trial records alike.
export const buildUpsertItem = ({
  item, fromDate, toDate, businessDate,
}) => {
  const updatedItem = {
    ...item, fromDate, toDate, businessDate,
  };
  if (item.recordType === 'NORMALRECORD') {
    updatedItem.isNormalRecord = true;
    updatedItem.isTrialRecord = false;
  }
  if (item.recordType === 'TRIALRECORD') {
    updatedItem.isTrialRecord = true;
    updatedItem.isNormalRecord = false;
  }
  return updatedItem;
};

export default {
  amountFields,
  TRIAL_BUILD_NOTE,
  shouldConfirmTrialBuild,
  buildUpsertItem,
};
